import { useDispatch, useSelector } from 'react-redux'
import { updateRole } from '../actions/role-org.action'
import { Button, ButtonGroup } from 'react-bootstrap'
import { useOrgSeleteStore, useRightOrgProfileStore } from '../store/layout'

function NavRoleOrg() {
  const { orgRole, isLoadingOrg } = useRightOrgProfileStore()
  const { setOrgSelete } = useOrgSeleteStore()
  const roleId = useSelector((state) => state.roleReducer.role)
  const dispatch = useDispatch()
  const handleChange = (d) => {
    setOrgSelete(d)
    dispatch(updateRole(d.org_id))
  }

  return (
    <div
      xl={4}
      className="mb-3 mt-1"
      style={{ maxWidth: '100vw', overflowY: 'auto' }}
    >
      {isLoadingOrg ? (
        <span className="small"> Loading...</span>
      ) : orgRole.length > 0 ? (
        <ButtonGroup
          aria-label="Basic example"
          style={{ borderRadius: '0.375rem' }}
          className="shadow-sm"
        >
          {orgRole.map((d, i) => (
            <Button
              key={`btn-${i}`}
              variant={`${
                +roleId === d.org_id ? 'custom-active' : 'custom-default'
              }`}
              style={{ whiteSpace: 'nowrap' }}
              className="px-4"
              onClick={() => {
                handleChange(d)
              }}
            >
              {d.org}
            </Button>
          ))}
        </ButtonGroup>
      ) : (
        <span className="text-danger small">
          **ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT**{' '}
        </span>
      )}
    </div>
  )
}

export default NavRoleOrg
